/**
 * @Author: 左建
 * @Date: 2022/8/18 17:30
 * @LastEditTime: 2022/8/18 17:30
 * @Description: 新增课程静态配置
*/

export function getAddFormInitVal () {
    return {
        SourceName: "", // 课程名称
        VideoName: "",
        ConverImg: "", // 课程封面
        SourceType: undefined, // 课程类型
        ClassId: undefined, // 所属分组
        Content: "", // 课程详情
        SourceTime: [], // SourceTime
        JoinMode: undefined, // 参与学员
        Credit: undefined, // 学分
        MinClassHours: undefined, // 最少学时
        DisplayMode: undefined
    }
}
export const JOIN_MODE = Object.freeze({
    0: "全员参与",
    1: "按部门/学员参与"
})

export const COURSE_SHOW = Object.freeze({
    0: "全员展示",
    1: "按部门/学员展示"
})
